"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSlug = void 0;
/**
 * Generate slugs for friendly urls (i.e. in kebab-case)
 * @public
 *
 * @param str - Text string to evaluate
 *
 * @returns  The string formated to kebab-case without non-words caracters
 *
 *
 * @example
 * ```ts
 * cont result = toSlug('I'm a cute Post Title')
 * console.log(result);
 * // -> 'im-a-cute-post-title'
 * ```
 */
function toSlug(str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/ & /g, ' and ')
        .replace(/ \| /g, ' or ')
        .replace(/[ ]+/g, '-')
        .replace(/[-]+/g, '-')
        .replace(/[^a-z0-9-]+/g, '');
}
exports.toSlug = toSlug;
//# sourceMappingURL=to-slug.js.map